// extracted by mini-css-extract-plugin
export var cText = "styles-module--c-text--e22c5";